const styles = theme => ({
	
	icon: {
		color: '#009AC9',
	},

	iconUnchecked: {
		color: '#707070',
	},		

	iconDisabled: {
		color: '#C5C5C5',
	},
});

export default styles;